export class PagerErrorConfig {
  formReference: string;
  pagesInError: number[];
}
